import React, { useState } from "react";
import { GstSignatoryDetails } from ".";
import {
  isEmailValid,
  isPanValid,
  returnInputFieldLength,
} from "../../../../utils/commonFunctions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  DisableiIcon,
  EnableiIcon,
  RedCheckIcon,
  VerifyIcon,
  WhiteCheckIcon,
} from "../../../../assets/images";
import { PanVerifyType } from "../../../../redux/services/serviceTypes";
import { BusinessAddressListType } from "../../../../redux/clientSettings/clientSettingTypes";

type AppProps = {
  handleGstChange: (e: any) => void;
  gstSignatoryDeatils: GstSignatoryDetails;
  authorizedPanVerifyDetails: PanVerifyType | null;
  businessAddressData: BusinessAddressListType | undefined;
  getPanDetails: (e: any) => void;
};

const GstSignatoryDeatils = ({
  handleGstChange,
  gstSignatoryDeatils,
  authorizedPanVerifyDetails,
  businessAddressData,
  getPanDetails,
}: AppProps) => {
  const {
    authorizedSignatoryPanNumber,
    authorizedSignatoryEmail,
    authorizedSignatoryName,
    authorizedSignatoryPhoneNumber,
  } = gstSignatoryDeatils;

  const [isHovered, setIsHovered] = useState(false);
  return (
    <div className="recurring-job mb-3">
      <div className="row">
        <div className="col-md-12">
          <h6>Authorized GST Signatory</h6>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div className="position-relative">
                <label htmlFor="Legal Name">Signatory PAN Number</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="authorizedSignatoryPanNumber"
                  value={authorizedSignatoryPanNumber}
                  onChange={(e) => {
                    if (e.target.value.length <= 10) {
                      handleGstChange(e);
                    }
                  }}
                />
                <span
                  className="position-absolute"
                  style={{ top: "30px", right: "5px" }}
                >
                  {(authorizedPanVerifyDetails?.status === "VALID" &&
                    authorizedSignatoryPanNumber?.length === 10) ||
                  (businessAddressData &&
                    businessAddressData?.authorized_signatory_pan_details
                      ?.status === "VALID" &&
                    businessAddressData?.authorized_signatory_pan_details
                      ?.pan === authorizedSignatoryPanNumber &&
                    authorizedSignatoryPanNumber?.length === 10) ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        <Tooltip id="button-view-filter-invoice">
                          <div>
                            <div className="text-left">
                              Full Name :{" "}
                              {businessAddressData
                                ?.authorized_signatory_pan_details?.full_name
                                ? businessAddressData
                                    ?.authorized_signatory_pan_details
                                    ?.full_name
                                : "NA"}
                            </div>
                            <div className="text-left">
                              PAN No :{" "}
                              {businessAddressData
                                ?.authorized_signatory_pan_details?.pan
                                ? businessAddressData
                                    ?.authorized_signatory_pan_details?.pan
                                : "NA"}
                            </div>
                            <div className="text-left">
                              Category :{" "}
                              {businessAddressData
                                ?.authorized_signatory_pan_details?.category
                                ? businessAddressData
                                    ?.authorized_signatory_pan_details?.category
                                : "NA"}
                            </div>
                            <div className="text-left">
                              Status :{" "}
                              {businessAddressData
                                ?.authorized_signatory_pan_details?.status
                                ? businessAddressData
                                    ?.authorized_signatory_pan_details?.status
                                : "NA"}
                            </div>
                          </div>
                        </Tooltip>
                      }
                    >
                      <img src={EnableiIcon} alt="enable" />
                    </OverlayTrigger>
                  ) : (
                    <img src={DisableiIcon} alt="disable" />
                  )}
                </span>
              </div>
              {(authorizedPanVerifyDetails?.status === "VALID" &&
                authorizedSignatoryPanNumber?.length === 10) ||
              (businessAddressData &&
                businessAddressData?.authorized_signatory_pan_details
                  ?.status === "VALID" &&
                businessAddressData?.authorized_signatory_pan_details?.pan ===
                  authorizedSignatoryPanNumber &&
                authorizedSignatoryPanNumber?.length === 10) ? (
                <span>
                  <img src={VerifyIcon} alt="pan" />{" "}
                  <span style={{ color: "#28a745" }}>PAN is Verified</span>
                </span>
              ) : authorizedPanVerifyDetails?.status === "INVALID" ? (
                <span className="text-danger">PAN is Invalid</span>
              ) : (
                <span className="input-length">
                  {returnInputFieldLength(
                    authorizedSignatoryPanNumber?.length,
                    10
                  )}
                </span>
              )}
            </div>
          </form>
        </div>
        <div className="col-md-2 mt-4">
          <div className="form-group mt-3">
            <button
              className="btn btn-outline"
              disabled={
                (authorizedSignatoryPanNumber &&
                authorizedSignatoryPanNumber?.length > 9
                  ? false
                  : true) ||
                (authorizedSignatoryPanNumber?.length &&
                  !isPanValid(
                    authorizedSignatoryPanNumber?.length
                      ? authorizedSignatoryPanNumber?.trim()
                      : ""
                  ))
                  ? true
                  : false
              }
              onClick={(e) => {
                getPanDetails(e);
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <img
                src={isHovered ? WhiteCheckIcon : RedCheckIcon}
                alt="check"
              />{" "}
              <span>Verify</span>
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="Signatory Name">Signatory Name</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="authorizedSignatoryName"
                  value={authorizedSignatoryName}
                  onChange={(e) => handleGstChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="Signatory Email">Signatory Email</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="authorizedSignatoryEmail"
                  value={authorizedSignatoryEmail}
                  onChange={(e) => handleGstChange(e)}
                />
                <span className="text-danger">
                  {authorizedSignatoryEmail?.length &&
                  !isEmailValid(authorizedSignatoryEmail)
                    ? "Email not valid"
                    : ""}
                </span>
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label>Phone Number</label>
                <input
                  type="number"
                  className={`form-control`}
                  name="authorizedSignatoryPhoneNumber"
                  value={
                    authorizedSignatoryPhoneNumber
                      ? authorizedSignatoryPhoneNumber
                      : ""
                  }
                  onChange={(e) => {
                    if (e.target.value.length <= 10) {
                      handleGstChange(e);
                    }
                  }}
                  maxLength={11}
                  onWheel={(event) => event.currentTarget.blur()}
                />
                <span className="input-length">
                  {returnInputFieldLength(
                    authorizedSignatoryPhoneNumber
                      ? authorizedSignatoryPhoneNumber.toString().length
                      : 0,
                    10
                  )}
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GstSignatoryDeatils;
